import './App.css';
import {
    Button,
    Card,
    CardContent, CardHeader, CardMedia,
    Container,
    FormControl, FormControlLabel, FormLabel, Grid,
    InputLabel,
    MenuItem, Radio, RadioGroup,
    Select,
    TextField,
    Typography
} from "@mui/material";
import React, {useRef, useState} from "react";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";

import moment from "moment";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import {esES} from "@mui/x-date-pickers/locales";
import ReCAPTCHA from "react-google-recaptcha";
import axios, {Axios} from "axios";
import './assets/ammper_logo.png';


function App() {
    moment.locale("es")
    const [contactForm, setContactForm] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [email, setEmail] = useState('');
    const [address, setAddress] = useState('');
    const [eventDate, setEventDate] = useState(moment);

    const [SuccessMsg, setSuccessMsg] = useState("")
    const [ErrorMsg, setErrorMsg] = useState("")
    const [valid_token, setValidToken] = useState([]);

    const SITE_KEY = "6LdXzfUmAAAAAEFsMd4AoVcSnayVe_V4Y32uelfx";
    const SECRET_KEY = "6LdXzfUmAAAAAPOE4msGMHlmrxul87V6AfvGN5Nx";

    const NONE = 0;
    const PHONE = 1;
    const EMAIL = 2;
    const ADDRESS = 3;

    const [hiddenPhone, setHiddenPhone] = useState(true);
    const [hiddenEmail, setHiddenEmail] = useState(true);
    const [hiddenAddress, setHiddenAddress] = useState(true);
    const [hiddenWitness, setHiddenWitness] = useState(true);
    const [btn_enabled, setBtnEnabled] = useState(false)
    const [denounceType, setDenounceType] = useState(NONE)
    const [showForm, setShowForm] = useState("inline")
    const [showThankyou, setShowThankyou] = useState("none")

    const [denouncedName, setDenouncedName] = useState('');
    const [description, setDescription] = useState("");
    const [witnessName, setWitnessName] = useState("");
    const [eventPlace, setEventPlace] = useState("");
    const [thereAreWitness, setThereAreWitness] = useState(0);
    const [complaintType, setComplaintType] = useState('Queja');
    const [sending, setSending] = useState("Enviar")

    const witnessHandler = (e)=>{
        setThereAreWitness(e.target.value);
        setHiddenWitness((1 * e.target.value) === 0);
    }

    const captchaRef = useRef(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        let token = captchaRef.current.getValue();
        captchaRef.current.reset();

        if (token) {
            let date = new Date(eventDate);
            let event = date.getDate() + "-"+ (date.getMonth() + 1) + "-" + date.getFullYear();
            let data = {
                name: name,
                conctactForm: contactForm,
                phone: phone,
                email: email,
                address: address,
                denouncedName: denouncedName,
                complaintType: complaintType,
                date:event,
                eventPlace: eventPlace,
                description: description,
                witnessName: witnessName
            }
            setBtnEnabled(true)
            setSending("Enviando...")
            fetch('https://pltbx5gjhb.execute-api.us-east-1.amazonaws.com/dev/create', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json'
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(data);
                    // Handle data
                    setBtnEnabled(false)
                    setSending("Enviar")
                    //alert("Denuncia enviada")
                    setDenouncedName("")
                    setDescription("")
                    setWitnessName("")
                    setEventPlace("")
                    setThereAreWitness(0)
                    setComplaintType("Queja")
                    setHiddenPhone(true)
                    setHiddenEmail(true)
                    setHiddenAddress(true)
                    setHiddenWitness(true)
                    setBtnEnabled(false)
                    setDenounceType(NONE)
                    setShowForm("none")
                    setShowThankyou("")
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth',
                    });
                })
                .catch((err) => {
                    console.log(err.message);
                    setBtnEnabled(false)
                    setSending("Enviar")
                    alert("No se envió la denuncia")
                });
            console.log(data);
        }
    }

    const verifyToken = async (token) => {
        let APIResponse = [];

        try {
            let response = await Axios.post(`http://localhost:8000/verify-token`, {
                reCAPTCHA_TOKEN: token,
                Secret_Key: SECRET_KEY,
            });

            APIResponse.push(response['data']);
            return APIResponse;
        } catch (error) {
            console.log(error);
        }
    };

    const handleChangePeriod = (newValue) => {
        setEventDate(newValue);
        fetchData(newValue);
    }

    const fetchData = (newPeriod) => {
        const newDate = new Date(newPeriod);
    }

    const handleChange = (event) => {
        setContactForm(event.target.value);
        setEmail('')
        setPhone('')
        setAddress('')
        setHiddenPhone(true)
        setHiddenEmail(true)
        setHiddenAddress(true)
        switch (event.target.value){
            case PHONE:
                setHiddenPhone(false)
                break;
            case EMAIL:
                setHiddenEmail(false)
                break
            case ADDRESS:
                setHiddenAddress(false)
                break;

        }
    };

    const onChangeCaptcha = (value) => {
        console.log("Captcha value:", value);
    }

    function handleReCAPTCHA(response) {
        console.log(response)
    }
    const background = "";
    const styles = {
        container: {
            backgroundImage: 'url(${backgroundImage})',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            width: '100vw',
            height: '100vh'
        }
    };

    return (
        <React.Fragment>
            <form method={"post"} onSubmit={handleSubmit} style={{
                "display":showForm
            }}>
                <Container fixed sx={{mt:3}}>
                    <Card>
                        <CardContent>
                            <CardMedia
                                component="img"
                                image={"https://ammper.com/assets/images/demo/modern-agency/logo/ammper-logo.png"}
                                alt="Logo"
                                style={{
                                    "max-width":"250px"
                                }}
                            />
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Typography component={"div"} sx={{mt:3}}>
                                        <strong>Denuncias</strong>
                                    </Typography>
                                    <Typography component={"div"} sx={{mt:3}}>
                                        En Ammper estamos comprometidos a <b>realizar de forma ética todas nuestras actividades</b>, por lo tanto, el incumplimiento a nuestro código de ética o de las leyes aplicables debe ser denunciado.
                                    </Typography>
                                    <Typography component={"div"} sx={{mt:3}}>
                                        Ayúdanos comunicando cualquier preocupación sobre nuestras empresas, la información proporcionada será tratada de manera confidencial únicamente para la investigación correspondiente y analizada por personal especializado.
                                    </Typography>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Card sx={{mt:3}}>
                        <CardContent>
                            <Typography variant="h5" component="div" sx={{mt:3}}>
                                Tus datos
                            </Typography>
                            <span className={"subtitle"}>
                                Estos datos son opcionales
                            </span>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <TextField
                                            id="standard-required"
                                            label="Nombre completo"
                                            variant="standard"
                                            fullWidth
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                            autoComplete={"off"}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-standard-label">¿Como quieres ser contactado?</InputLabel>
                                        <Select
                                            id="demo-simple-select-standard"
                                            value={contactForm}
                                            onChange={handleChange}
                                            label="¿Como quieres ser contactado?"
                                            defaultValue={denounceType}
                                        >
                                            <MenuItem select value={0}>Ninguno</MenuItem>
                                            <MenuItem select value={1}>Teléfono</MenuItem>
                                            <MenuItem value={2}>Email</MenuItem>
                                            <MenuItem value={3}>A tu dirección</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} id="phone" hidden={hiddenPhone}>
                                    <TextField
                                        id="standard-required"
                                        label="Teléfono"
                                        variant="standard"
                                        fullWidth
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        autoComplete={"off"}
                                        type={"tel"}
                                    />
                                </Grid>
                                <Grid item xs={12} id="email" hidden={hiddenEmail}>
                                    <TextField
                                        id="standard-required"
                                        label="Email"
                                        variant="standard"
                                        fullWidth
                                        inputProps={{ inputMode: 'email' }}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete={"off"}
                                        type={"email"}
                                    />
                                </Grid>
                                <Grid item xs={12} id="address" hidden={hiddenAddress}>
                                    <TextField
                                        id="standard-required"
                                        label="Dirección"
                                        variant="standard"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        autoComplete={"off"}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <Card sx={{mt:3}}>
                        <CardContent>
                            <Typography variant="h5" component="div">
                                Nombre del denunciado
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField
                                        required
                                        id="standard-required"
                                        label="Nombre del denunciado"
                                        variant="standard"
                                        fullWidth
                                        value={denouncedName}
                                        onChange={(e) => setDenouncedName(e.target.value)}
                                        autoComplete={"off"}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <Card sx={{
                        mt:3,
                        mb:3
                    }}>
                        <CardContent>
                            <Typography variant="h5" component="div">
                                Denuncia
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <FormLabel id="demo-radio-buttons-group-label">Tipo de Denuncia</FormLabel>
                                    <RadioGroup
                                        aria-labelledby="demo-radio-buttons-group-label"
                                        defaultValue="Queja"
                                        name="radio-buttons-group"
                                        row
                                        required
                                        value={complaintType}
                                        onChange={(e) => setComplaintType(e.target.value)}
                                    >
                                        <FormControlLabel value="Queja" control={<Radio />} label="Queja" />
                                        <FormControlLabel value="Denuncia" control={<Radio />} label="Denuncia" />
                                    </RadioGroup>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="es-ES" dateLibInstance={moment}
                                                          localeText={esES.components.MuiLocalizationProvider.defaultProps.localeText}
                                    >
                                        <DatePicker
                                            label="Fecha de los hechos *"
                                            value={eventDate}
                                            onChange={(newValue) => handleChangePeriod(newValue)}
                                            format="DD/MM/YYYY"
                                            required
                                        />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <TextField
                                        required
                                        id="standard-required"
                                        label="Lugar de los hechos"
                                        variant="standard"
                                        fullWidth
                                        value={eventPlace}
                                        onChange={(e) => setEventPlace(e.target.value)}
                                        autoComplete={"off"}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        id="standard-required"
                                        label="Descripción de los hechos"
                                        variant="standard"
                                        fullWidth
                                        multiline
                                        required
                                        rows={4}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        autoComplete={"off"}
                                    />
                                </Grid>
                                <Grid item xs={6} md={3}>

                                        <FormLabel id="there_are_witness">Existen testigos</FormLabel>
                                        <RadioGroup
                                            required
                                            aria-labelledby="there_are_witness"
                                            name="controlled-radio-buttons-group"
                                            value={thereAreWitness}
                                            onChange={witnessHandler}
                                            row
                                            defaultValue={0}
                                        >
                                            <FormControlLabel value={0} control={<Radio />} label="No" />
                                            <FormControlLabel value={1} control={<Radio />} label="Si" />
                                        </RadioGroup>

                                </Grid>
                                <Grid item xs={12} md={8} hidden={hiddenWitness}>
                                    <TextField
                                        id="standard-required"
                                        label="Nombre del testigo"
                                        variant="standard"
                                        fullWidth
                                        value={witnessName}
                                        onChange={(e) => setWitnessName(e.target.value)}
                                        autoComplete={"off"}
                                    />
                                </Grid>
                                <Grid item md={12} xs={12} textAlign={"center"}>
                                    <ReCAPTCHA
                                        className="recaptcha"
                                        sitekey={SITE_KEY}
                                        ref={captchaRef}
                                    />
                                </Grid>
                                <Grid item md={12} xs={12} textAlign={"center"}>
                                    <Button disabled={btn_enabled} variant={"outlined"} type={"submit"} color={"primary"}>{sending}</Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Container>
            </form>
            <div id="test" style={{
                "background-color":"#fff",
                "height":"100vh",
                "padding": "100px",
                "display":showThankyou
            }}>
                <CardMedia
                    component="img"
                    image={"https://ammper.com/assets/images/demo/modern-agency/logo/ammper-logo.png"}
                    alt="Logo"
                    style={{
                        "max-width":"250px"
                    }}
                />
                <h4>
                    Gracias por tu denuncia, la información proporcionada será tratada de manera confidencial únicamente
                    para la investigación correspondiente y analizada por personal especializado.
                </h4>
                <a href="https://ammper.com/denuncias/index.html">Crear nueva denuncia</a>
            </div>
        </React.Fragment>
    );
}

export default App;
